<template>
  <svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1L8 6.99983L15 1" stroke="black" stroke-width="2" stroke-linecap="round" />
  </svg>
</template>
